<template>
	<div class="welcome box box--primary">
		<div class="welcome__title">{{ $t('Input Alamat') }}</div>
		<div class="welcome__description">
			<div>Lengkapi alamat toko anda.</div>
		</div>
		<div class="welcome__content">
			<form @submit.prevent="saveAddress()">
				<div class="row">
					<div class="col-md-12">
						<div class="form-group">
							<label>Kota / Kecamatan <span class="text-danger">*</span></label>
							<multiselect v-model="selectedSubdistrict" :custom-label="cityLabel"
								:show-labels="false" track-by="subdistrict_id"
								@close="subdistrictValidation"
								placeholder="Masukkan Kota / Kecamatan (minimal 3 huruf)"
								:options="subdistricts"
								@search-change="fetchSubdistricts">
							</multiselect>
							<small v-if="errorMessages.subdistrict" class="text-danger">{{ errorMessages.subdistrict }}</small>
						</div>
					</div>
					<div class="col-md-12">
						<div class="form-group">
							<label>Alamat Lengkap <span class="text-danger">*</span></label>
							<textarea name="address" class="form-control" rows="3" placeholder="Alamat Lengkap" v-model="address" required></textarea>
							<small v-if="errorMessages.address" class="text-danger">{{ errorMessages.address }}</small>
						</div>
					</div>
				</div>
			</form>
		</div>
		<div class="welcome__footer">
			<div class="welcome__info">{{ $t('Step 1 of 1') }}</div>
			<div class="welcome__next">
				<button type="buttom" class="btn btn-primary" :class="{'is-loading': isSavingAddress}" @click="saveAddress()">
					<span>{{ $t('Next') }}</span><i class="material-icons">chevron_right</i>
				</button>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { getAxiosErrorMessage, duplicateVar } from '@/lib/helper';
import shipping from '@/api/shipping';

export default {
	name: 'SellerAddres',
	components: {},
	data() {
		return {
			isSavingAddress: false,
			isLoadingSubdistrics: false,
			subdistricts: [],
			selectedSubdistrict: null,
			subdistrictKeyword: '',
			address: '',
			errorMessages: {
				subdistrict: '',
				address: '',
			},
		};
	},
	methods: {
		...mapActions({
			updateStore: 'updateStore',
		}),
		getSubdistricts() {
			this.isLoadingSubdistrics = true;
			const subdistrictIds = JSON.stringify(this.originIds);
			const params = {
				page: 1,
				subdistrict_ids: subdistrictIds,
				get_complete_data: true,
				keyword: this.subdistrictKeyword,
			};
			const callback = (response) => {
				const subdistricts = response.data;
				this.subdistricts = subdistricts;
				this.isLoadingSubdistrics = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Get Subdistricts',
					text: message,
				});
				this.isLoadingSubdistrics = false;
			};
			shipping.getCompleteSubdistricts(params, callback, errorCallback);
		},
		fetchSubdistricts(query) {
			if (query.length >= 3) {
				this.subdistrictKeyword = query;
				this.getSubdistricts();
			}
		},
		// eslint-disable-next-line camelcase
		cityLabel({ province_name, city_name_with_type, subdistrict_name }) {
			// eslint-disable-next-line camelcase
			return `${province_name}, ${city_name_with_type}, ${subdistrict_name}`;
		},
		subdistrictValidation() {
			if (this.selectedSubdistrict) {
				this.errorMessages.subdistrict = '';
			} else {
				this.errorMessages.subdistrict = 'Kota Wajib Dipilih';
			}
		},
		addressValidation() {
			if (this.address.length <= 0) {
				this.errorMessages.address = 'Alamat Lengkap Wajib Diisi';
			} else {
				this.errorMessages.address = '';
			}
		},
		validateAllForm() {
			this.subdistrictValidation();
			this.addressValidation();
		},
		saveAddress() {
			this.validateAllForm();
			const isErrorExist = Object.values(this.errorMessages).find(val => val !== '');
			if (isErrorExist) {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Oops',
					text: 'Semua isian harus diisi.',
				});
				return;
			}

			this.isSavingAddress = true;
			const store = duplicateVar(this.store);

			store.name = this.user.name;
			store.email = this.user.email;
			store.address = this.address;

			const provinceId = this.selectedSubdistrict ? this.selectedSubdistrict.province_id : 0;
			const provinceName = this.selectedSubdistrict ? this.selectedSubdistrict.province_name : '';
			const province = {
				id: provinceId,
				name: provinceName,
			};
			const cityId = this.selectedSubdistrict ? this.selectedSubdistrict.city_id : 0;
			const cityName = this.selectedSubdistrict ? this.selectedSubdistrict.city_name_with_type : '';
			const city = {
				id: cityId,
				name: cityName,
			};
			const subdistrictId = this.selectedSubdistrict ? this.selectedSubdistrict.subdistrict_id : 0;
			const subdistrictName = this.selectedSubdistrict ? this.selectedSubdistrict.subdistrict_name : '';
			const subdistrict = {
				id: subdistrictId,
				name: subdistrictName,
			};
			const zipCode = this.selectedSubdistrict ? this.selectedSubdistrict.zip : '';

			store.shipping.origin.province = province;
			store.shipping.origin.city = city;
			store.shipping.origin.subdistrict = subdistrict;
			store.shipping.origin.zip = zipCode;

			const cb = () => {
				this.isSavingAddress = false;
				this.$notify({
					group: 'app',
					title: 'Sukses',
					text: 'Alamat berhasil disimpan.',
					type: 'success',
				});

				this.$emit('set-step', 'bank');
			};
			const errorCb = () => {
				this.isSavingAddress = false;
			};
			this.updateStore({ store, cb, errorCb });
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			store: 'store',
		}),
	},
	watch: {
		address() {
			this.addressValidation();
		},
	},
};
</script>
